export default __webpack_public_path__ + "static/media/Signup.458d22da.svg";